import { Injectable } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import { ElementRef } from '@angular/core';
export class ContextMenuService {
private contextMenu: OverlayRef[] = [];
private refs: ElementRef[] = [];
constructor() {}
/**
 * @param {?} overlay
 * @return {?}
 */
setContextMenuOverlay(overlay: OverlayRef) {
      this.contextMenu = this.contextMenu.concat(overlay);
   }
/**
 * @return {?}
 */
getContextMenuOverlay(): OverlayRef[] {
      return this.contextMenu;
   }
/**
 * @return {?}
 */
public closeAllContextMenus(): void {
      if (this.contextMenu) {
         this.contextMenu.forEach((overlay, index) => {
            overlay.detach();
            overlay.dispose();
         });
      }
      this.contextMenu = [];
   }
/**
 * @param {?} el
 * @return {?}
 */
setRef(el: ElementRef) {
      this.refs = this.refs.concat(el);
   }
/**
 * @return {?}
 */
getRef(): ElementRef[] {
      return this.refs;
   }
/**
 * @return {?}
 */
public destroyAllRef(): void {
      this.refs = [];
   }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ContextMenuService_tsickle_Closure_declarations() {
/** @type {?} */
ContextMenuService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ContextMenuService.ctorParameters;
/** @type {?} */
ContextMenuService.prototype.contextMenu;
/** @type {?} */
ContextMenuService.prototype.refs;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
